import React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";
import { Button } from "../ui/button";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { CgFolderAdd } from "react-icons/cg";
import { useSidebar } from "../ui/sidebar";
import {
  selectCurrentRoom,
  setActiveTab,
  setUnSeenFiles,
} from "@/context/features/room/roomSlice";
import { Badge } from "../ui/badge";
import { TypographyNumber } from "./numbers";
import { cn } from "@/lib/utils";

export default function FileToggle() {
  const { setOpen, setOpenMobile, isMobile, toggleSidebar } = useSidebar();
  const { unSeenFiles, activeTab } = useSelector(selectCurrentRoom);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="outline"
          className={cn("relative flex gap-2 ", !isMobile && "h-10 pt-[11px]")}
          size={isMobile ? "icon" : "default"}
          onClick={() => {
            if (activeTab === "files") {
              toggleSidebar();
            } else {
              setOpen(true);
              if (isMobile) setOpenMobile(true);
            }
            dispatch(setActiveTab("files"));
            dispatch(setUnSeenFiles(0));
          }}
        >
          {unSeenFiles > 0 && (
            <Badge
              className="absolute p-1 w-5 h-5 bg-green-500 rounded-full -top-2 -start-2 pt-1.5 text-[10px] border border-background shadow"
              dir="ltr"
            >
              <TypographyNumber value={unSeenFiles} />
            </Badge>
          )}
          <CgFolderAdd className="mb-1" size={23} />
          {!isMobile && t("files")}
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top">{t("files")}</TooltipContent>
    </Tooltip>
  );
}
